module.exports = __webpack_public_path__ + "img/nolan-sigma.8d92cee3.svg";